import {message} from 'antd';

export class TaskManagerService {
  client: any;
  constructor({client}: any) {
    this.client = client;
  }
  serviceName = 'bot';
  async getStatus(userId: number) {
    try {
      const result = await this.client.post(`${this.serviceName}/status`, {user_id: userId});
      return result.data.status;
    } catch (e) {
      message.error(`Can not get the status for user ${userId}. Please try again later.`, 5);
      return false;
    }
  }
  async startServer(userId: number) {
    try {
      await this.client.post(`${this.serviceName}/start`, {user_id: userId});
      return 'success';
    } catch (e) {
      message.error('We were not able to start the server. Please try again later.', 5);
      return 'invalid';
    }
  }
}
